'use strict';

module.exports = {
  api: {
    domains: {
      feed: 'https://stage-feed.tunein.com',
      opml: 'https://stage-opml.tunein.com',
      reports: 'https://stage-reports.tunein.com',
      api: 'https://stage-api.tunein.com',
      stream: '//stage-stream.radiotime.com',
      local: '/api/v1'
    },
    partnerId: 'RadioTime',
    version: '2.0'
  }
};